module.exports = __webpack_public_path__ + "assets/b14.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b14.png
// module id = 599
// module chunks = 0